import { z } from "zod";
import {
  ReceivableDocument,
  ReceivableDocumentType,
  PendingReceivableDocument,
} from "../../../utils/types";

export const documentFormSchema = z.object({
  documentType: z.nativeEnum(ReceivableDocumentType, {
    required_error: "Selecione o tipo do documento",
  }),
  description: z
    .string()
    .max(255, "Máximo de 255 caracteres")
    .optional(),
  documentUrl: z
    .string()
    .url("Informe uma URL válida")
    .optional()
    .or(z.literal("")),
  file: z.any().optional(),
});

export type DocumentFormValues = Omit<z.infer<typeof documentFormSchema>, "file"> & { file?: File };

export type DocumentListItem =
  | { kind: "existing"; document: ReceivableDocument }
  | { kind: "pending"; document: PendingReceivableDocument };

export const generateTempDocumentId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `temp-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

